import React from 'react';
import i18next from 'i18next';

import NumberFormat from '~components/NumberFormat';
import { ROUTES } from '~constants/routes';
import { getDate } from '~utils/date';

export const breadcrumbPaths = id => {
  const paths: {
    name: string;
    url?: string;
  }[] = [
    { name: i18next.t('projectDetail:projects'), url: ROUTES.IIRSA_PROJECTS },
    { name: i18next.t('projectDetail:projectDetail'), url: `${ROUTES.IIRSA_PROJECT_DETAIL}/${id}` }
  ];

  return paths;
};

export const renderSubtitle = (element: string) =>
  i18next
    .t(`technicalSheet:${element}`)
    .toString()
    .toUpperCase();

export const renderText = (subtitle: string, value: string | number, translate: boolean = false, isNumber: boolean = false) => {
  const subtitleDisplay = renderSubtitle(subtitle);
  if (translate) {
    return { subtitle: subtitleDisplay, value: i18next.t(`technicalSheet:${value}`).toString() };
  }
  if (typeof value === 'string') {
    if (isNumber) {
      return {
        subtitle: subtitleDisplay,
        value: <NumberFormat value={Number.parseFloat(value.toString())} dollarPrefix/>
      }
    }
    return {
      subtitle: subtitleDisplay,
      value
    };
  }
  return {
    subtitle: subtitleDisplay,
    value: <NumberFormat value={value} dollarPrefix />
  };
};

export const renderDate = (subtitle: string, date: string) => {
  const subtitleDisplay = renderSubtitle(subtitle);
  const value = date ? getDate(date) : '-';
  return { subtitle: subtitleDisplay, value };
};

export const renderBool = (subtitle: string, value: boolean) => {
  const subtitleDisplay = renderSubtitle(subtitle);
  const text = value ? i18next.t('technicalSheet:yes') : i18next.t('technicalSheet:no');
  return { subtitle: subtitleDisplay, value: text.toString() };
};

export const renderMany = (subtitle: string, value: string[]) => {
  const subtitleDisplay = renderSubtitle(subtitle);
  return { subtitle: subtitleDisplay, value: value.join(' - ') };
};
